module.exports = __webpack_public_path__ + "img/right-from-bracket.965951bf.svg";